// Constants
export const DATE_FORMATS = {
  full: "eeee dd MMM yyyy",
  time: "HH:mm",
};

export const TIME_ZONE = "UTC";

export const formatTimestampToDate = (data) => {
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    timeZone: "UTC", // keeps it consistent everywhere
  }).format(new Date(data));
};
